import { render, staticRenderFns } from "./coWithdrawAction.vue?vue&type=template&id=b21c48b0&scoped=true"
import script from "./coWithdrawAction.vue?vue&type=script&lang=js"
export * from "./coWithdrawAction.vue?vue&type=script&lang=js"
import style0 from "./coWithdrawAction.vue?vue&type=style&index=0&id=b21c48b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21c48b0",
  null
  
)

export default component.exports